import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useSelector} from 'react-redux';

import {DownloadExcelTemplate, SidePanel, UploadDocument} from 'front-onceforall-core';

import {pathDocumentTemplates} from '../../../../utils/path';
import {getDocumentName} from '../../../../utils/document';
import {pathResolver} from '../../../../utils/basePathHelper';

const DOCUMENT_TEMPLATE_PATH = `${pathDocumentTemplates}${getDocumentName('Liste des salariés étrangers')}.xlsx`;

const TEMPLATE_STEP_INDEX = 1;
const UPLOAD_STEP_INDEX = 2;

function getIdentitySpecimenSrc(locale) {
  let imgPath = '';
  switch (locale) {
    case 'fr':
      imgPath = 'resources/img/Image-Liste_TAT-FR.jpg';
      break;
    case 'en':
    case 'de':
    case 'it':
    default:
      imgPath = 'resources/img/Image-Liste_TAT-EN.jpg';
  }

  return pathResolver(imgPath);
}

function DownloadAndUploadForeignEmployeesDocumentPanel(props) {
  const currentLocale = useSelector(state => state.i18n.locale);
  const [currentStep, setCurrentStep] = React.useState(TEMPLATE_STEP_INDEX);

  function handleNextStep(noForeignWorkers) {
    if (noForeignWorkers) {
      const info = {
        documentTypeId: props.document.type.documentTypeId,
        documentTypeCode: props.document.type.code
      };
      props.onSubmit(props.document.uid, null, info);
    } else {
      setCurrentStep(UPLOAD_STEP_INDEX);
    }
  }

  function handlePreviousStep() {
    setCurrentStep(TEMPLATE_STEP_INDEX);
  }

  const getStep = () => {
    if (currentStep === TEMPLATE_STEP_INDEX) {
      return (
        <>
          <DownloadExcelTemplate
            document={props.document}
            onClose={props.onClose}
            onHandleSubmit={handleNextStep}
            pathDocumentTemplate={DOCUMENT_TEMPLATE_PATH}
          />
          <div className='mt-5 d-flex justify-content-center align-items-center'>
            <img
              alt="img specimen"
              src={getIdentitySpecimenSrc(currentLocale)}
              style={{maxWidth: '100%'}}
            />
          </div>
        </>
      );
    }

    const message = (
      <div className="col-12 my-4">
        <Translate value="document.foreignEmployees.uploadMessage.line1"/>
        <ul>
          <li><Translate value="document.foreignEmployees.uploadMessage.bullet1"/></li>
          <li><Translate value="document.foreignEmployees.uploadMessage.bullet2"/></li>
        </ul>
        <Translate value="document.foreignEmployees.uploadMessage.line2"/>
      </div>
    );
    const secondaryMessage = (
      <div className="col-12 my-4">
        <Translate value="document.foreignEmployees.secondaryUploadMessage"/>
      </div>
    );

    return (<UploadDocument
      document={props.document}
      documentEquivalences={[props.document.type]}
      onCancel={handlePreviousStep}
      onHandleSubmitFile={props.onSubmit}
      submitted={props.submitting}
      extensions={'.xlsx,.pdf'}
      message={message}
      secondaryMessage={secondaryMessage}
      showMetadataForm={false}
    />);
  };

  return (
    <SidePanel
      big
      onClose={props.onClose}
    >
      {getStep()}
    </SidePanel>
  );
}

DownloadAndUploadForeignEmployeesDocumentPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default DownloadAndUploadForeignEmployeesDocumentPanel;
